import React from 'react';
import { ISettingCategory } from '../../config/SettingsCategories';
import './SettingsCategoryPanel.css';
import { SettingsCategory } from '../../config/SettingsCategory';

export interface SettingsCategoryPanelProps {
	categories: ISettingCategory[];
	activeCategory: SettingsCategory | null;
	onCategoryClick: (categoryId: SettingsCategory) => void;
}

export const SettingsCategoryPanel: React.FC<SettingsCategoryPanelProps> = ({
	categories,
	activeCategory,
	onCategoryClick,
}) => {
	return (
		<nav className="settings-nav">
			{categories.map((category) => (
				<button
					key={category.id}
					className={`settings-nav-item ${
						activeCategory === category.id ? 'active' : ''
					}`}
					onClick={() => onCategoryClick(category.id as SettingsCategory)}
					type="button"
					title={category.description}
				>
					<div className="nav-item-icon">
						<category.icon />
					</div>
					<span className="nav-item-label">{category.title}</span>
				</button>
			))}
		</nav>
	);
};
